import superagent from 'superagent';
import config from '../config';
import parser from 'ua-parser-js';

const methods = ['get', 'post', 'put', 'patch', 'del'];

function formatUrl(path) {
    const adjustedPath = path[0] !== '/' ? '/' + path : path;
    if (adjustedPath !== '/restlogin' && adjustedPath !== '/acceptTerm' && adjustedPath !== '/declineTerm' && adjustedPath !== '/resetPwd' && adjustedPath !== '/getCompanyInfo' && localStorage.getItem("userlogin") !== "null" && localStorage.getItem("userlogin") !== null) {
      return window.location.hostname==="localhost"?config.apiPath + '/user' + adjustedPath:window.location.origin+"/api" + '/user' + adjustedPath;
    }
    return window.location.hostname==="localhost"?config.apiPath + adjustedPath:window.location.origin+"/api" + adjustedPath;
}


export default class ApiClient {
  constructor(req) {
    methods.forEach((method) =>
      this[method] = (path, { params, header, data } = {}) => new Promise((resolve, reject) => {
        const request = superagent[method](formatUrl(path));
        if (params) {
          request.query(params);
        }
        if (__SERVER__ && req.get('cookie')) {
          request.set('cookie', req.get('cookie'));
        }
        if (data) {
          request.send(data);
        }
        if (header) {
          request.set(header)
        }
        if(path === '/hidePswrdExpPopup'){
          const user = JSON.parse(localStorage.getItem('user'));
          request.set('username', user.UID);
          request.set('location', user.location);
        }
        if ((path !== '/restlogin' && path !== '/getCompanyInfo' && localStorage.getItem("userlogin") !== "null" && localStorage.getItem("userlogin") !== null) || path === '/resetPwd') {
          const user = JSON.parse(localStorage.getItem('user'));
          request.set('SID', user.SID);
          request.set('username', user.UID);
          request.set('location', user.location);
          request.set('Cache-Control','no-cache');
        }
        if(path === '/acceptTerm'){
          const user = JSON.parse(localStorage.getItem('user'));
          request.set('username', user.UID);
          request.set('location', user.location);
          request.set('Cache-Control','no-cache');
        }
        if(path === '/declineTerm'){
          const user = JSON.parse(localStorage.getItem('user'));
          request.set('username', user.id);
          request.set('location', user.location);
          request.set('sid', user.sid);
          request.set('Cache-Control','no-cache');
        }
        const ua = parser(navigator.userAgent);
        let platform;
        if (ua.os.name === 'Windows' || ua.os.name === 'Ubuntu' || ua.os.name === 'Linux' || ua.os.name === 'Mac OS') {
          platform = 'Desktop';
        } else if (ua.os.name === 'Android' || ua.os.name === 'iOS' || ua.os.name === 'BlackBerry') {
          platform = 'Tablet';
        } else { platform = 'Other'; }
        request.set('platform', platform);
        localStorage.setItem('platform', platform);
        request.end((err, response) => {
          const { body = {} } = response;
          if (body) {
            body.statusCode = response.statusCode;
          }
          if (err) {
            err.statusCode = response.statusCode;
          }
          return err ? reject(body || err) : resolve(body);
        });
      }));
  }
  /*
   * There's a V8 bug where, when using Babel, exporting classes with only
   * constructors sometimes fails. Until it's patched, this is a solution to
   * "ApiClient is not defined" from issue #14.
   * https://github.com/erikras/react-redux-universal-hot-example/issues/14
   *
   * Relevant Babel bug (but they claim it's V8): https://phabricator.babeljs.io/T2455
   *
   * Remove it at your own risk.
   */
  empty() {}
}
